/* Accounts flow route paths (receipts/payments with approval, ledger statement). Use as hrefLink in the menus. */

module.exports = Object.freeze({
  RECEIPT_ENTRY: "/accounts-flow/receipt",
  PAYMENT_ENTRY: "/accounts-flow/payment",
  VOUCHERS: "/accounts-flow/vouchers",
  ENTRY_VIEW: "/accounts-flow/entry",
  LEDGER_STATEMENT: "/accounts-flow/ledger-statement",
  CREDIT_NOTE: "/accounts-flow/credit-note",
  DEBIT_NOTE: "/accounts-flow/debit-note",
  JOURNAL: "/accounts-flow/journal",
  PURCHASE_BILL: "/accounts-flow/purchase-bill",
  ORDER_TRAIL: "/accounts-flow/order",
  ORDER_CREATE: "/accounts-flow/order/new",
});
